import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import "rxjs/add/operator/map";
import { environment } from '../../environments/environment';

@Injectable()
export class Auth0Service {
  private rootUrl = "http://192.168.1.217:8000";
  private state: string;
  private code_verifier: string;
  private code_challenge:string;

  constructor(private httpClient: HttpClient) { 
    this.rootUrl = environment.API_URL ? environment.API_URL : this.rootUrl;
  }

  generateRandomString(length: number, data_for:string): string {
    const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      result += charset.charAt(randomIndex);
    }
    localStorage.setItem(data_for, result);

    return result;
  }

  // Get Auth0 url for authentication
  Auth0AuthorizationUrl() {

    this.state = this.generateRandomString(5, 'state').toString();
    this.code_verifier = this.generateRandomString(50,'code_verifier').toString();
    const authorizeUrl = `${environment.auth0.authUrl}?response_type=code&client_id=${environment.auth0.clientId}&redirect_uri=${environment.auth0.redirectUri}&state=${this.state}&scope=openid profile email`;
   
    return authorizeUrl    
  }

  // Get authenticated user token

  getAuth0UserToken(code:any) {
    let data = {
      grant_type: 'authorization_code',
      client_id: environment.auth0.clientId,
      code: code,
      redirect_uri: environment.auth0.redirectUri,
    };
    return this.httpClient.post(environment.auth0.getAuth0UserToken, data, {});
  }
  
  // User Authentication
  verifyauth0UserToken(accessToken, login_type) {
    let data = {
      accessToken: accessToken,
      login_type: login_type,
      auth0UserInfoURI: environment.auth0.getauth0UserInfo
    };

    return this.httpClient.post(this.rootUrl + "/login_okta", data, {});
  }

   // Get stripe url for authentication
   stripeAuthorizationUrl() {
    localStorage.setItem('stripe_verify', 'True');
    const authorizeUrl = `${environment.stripe.authUrl}?response_type=code&client_id=${environment.stripe.clientId}&scope=read_write&redirect_uri=${environment.stripe.redirectUri}`;
    return authorizeUrl    
  }

  // Get stripe user
  getStripeUserToken(code:any, id = null) {
    let data = {
      id: (localStorage.getItem("userID")) ? localStorage.getItem("userID") : id,
      tokenURI: environment.stripe.tokenEndpoint,
      code: code,
    };
    return this.httpClient.post(this.rootUrl+ "/options/setStripeKeys", data, {});
  }

  // Get google oauth2 AuthorizationUrl for SMTP connection
  getGoogleAuthorizationUrl() {
    const scopes = [
      'https://www.googleapis.com/auth/gmail.send',
      'https://www.googleapis.com/auth/userinfo.profile',
      'https://www.googleapis.com/auth/userinfo.email',
    ];

    const authParams = new HttpParams()
      .set('client_id', environment.googleOAuth2.clientId)
      .set('redirect_uri', environment.googleOAuth2.redirectUri)
      .set('response_type', 'code')
      .set('scope', scopes.join(' '))
      .set('access_type', 'offline')
      .set('prompt', 'consent');

    return `${environment.googleOAuth2.authUrl}?${authParams}`;
  }

  // Exchange authorization code for tokens
  generateGoogleOAuth2Tokens(params: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const postData = new URLSearchParams();
    postData.set('code', params.code);
    postData.set('client_id', environment.googleOAuth2.clientId);
    postData.set('client_secret', environment.googleOAuth2.clientSecret);
    postData.set('redirect_uri', environment.googleOAuth2.redirectUri);
    postData.set('grant_type', 'authorization_code');

    return this.httpClient.post(environment.googleOAuth2.tokenEndpoint, postData.toString(), {
      headers,
    });
  }

  updateSMTPViaOAuth2Google(postData: any) {
    postData.id = localStorage.getItem("userID");
    return this.httpClient.post(this.rootUrl + "/options/setSMTPKeysViaOAuth2Google", postData, {});
  }


  // Get Outllook oauth2 AuthorizationUrl for SMTP connection
  getOutlookAuthorizationUrl() {
    const scopes = [
      'https://graph.microsoft.com/Mail.Send',
      'https://graph.microsoft.com/User.Read',
      'offline_access',
      'openid',
      'profile',
      'email'
    ];

    const authParams = new HttpParams()
      .set('client_id', environment.outlookOAuth2.clientId)
      .set('redirect_uri', environment.outlookOAuth2.redirectUri)
      .set('response_type', 'code')
      .set('scope', scopes.join(' '))
      .set('access_type', 'offline')
      .set('prompt', 'consent');

    return `${environment.outlookOAuth2.authUrl}?${authParams}`;
  }

  // Exchange authorization code for tokens and update
  updateSMTPViaOAuth2Outlook(params: any) {
    const postData = {
      id: localStorage.getItem("userID"),
      code: params.code
    };

    return this.httpClient.post(this.rootUrl + "/options/setSMTPKeysViaOAuth2Outlook", postData, {});
  }

  // Get Squareup oauth2 AuthorizationUrl for payment connection
  getSquareupAuthorizationUrl() {
    const scopes = [
      'MERCHANT_PROFILE_READ',
      'PAYMENTS_READ',
      'PAYMENTS_WRITE'
    ];

    const authParams = new HttpParams()
      .set('client_id', environment.squareupOAuth2.clientId)
      .set('redirect_uri', environment.squareupOAuth2.redirectUri)
      .set('response_type', 'code')
      .set('scope', scopes.join('+'))
      .set('session', 'false')

    return `${environment.squareupOAuth2.authUrl}?${authParams}`;
  }

  // Exchange authorization code for Squareup tokens/keys and update
  updateKeysViaOAuth2Squareup(params: any) {
    const postData = {
      id: localStorage.getItem("userID"),
      code: params.code
    };

    return this.httpClient.post(this.rootUrl + "/options/setKeysViaOAuth2Squareup", postData, {});
  }

  // Get OAuth2 Squareup keys
  getOAuth2SquareupKeys(userID: string) {
    const postData = {
      id: userID
    };

    return this.httpClient.post(this.rootUrl + "/options/getOAuth2SquareupKeys", postData, {});
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_services/auth0.service.ts